import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = {
  key: 0,
  class: "max-w-full lg:max-w-[936px] w-full lg:w-[936px] text-racq-dark-grey text-base-bold"
}
const _hoisted_4 = { class: "flex flex-col md:flex-row md:flex-wrap gap-4 w-full" }
const _hoisted_5 = ["data-test-id"]

import { computed } from 'vue';
import { RichText, Link, ComponentFields, Image, ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import { BackgroundColours } from '@/interfaces/forms/background-colour.interface';
import { IPromoCardImageItem } from '@/interfaces/entities/promo-card-image.interface';
import { TagBgColour, TagSize, TagTypes } from '@/enums/tag-enums';
import PromoCardImageContent from '@/components/PromoCardImage/PromoCardImageContent.vue';
import { usePageStore } from '@/store';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'PromoCardImageSlide',
  props: {
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const promoCardImages = computed(() => props.fields.items as IPromoCardImageItem[]);
const firstPromoCardImage = computed(() => promoCardImages.value[0] as IPromoCardImageItem);
const renderChevronSingle = computed(
  () => firstPromoCardImage.value.fields.isChevron.value && firstPromoCardImage.value.fields.chevronUrl
);

const dataTestId = usePageStore().dataTestId(props.rendering ?? firstPromoCardImage.value);

function isValidPrimaryButton(promoCardImage: IPromoCardImageItem) {
  if (promoCardImage.fields.primaryButton?.value.text && promoCardImage.fields.primaryButton) {
    return true;
  }
  return false;
}

function isValidSecondaryButton(promoCardImage: IPromoCardImageItem) {
  if (promoCardImage.fields.secondaryButton?.value.text && promoCardImage.fields.secondaryButton) {
    return true;
  }
  return false;
}

function getMaxImageWidthClasses() {
  const promoCards = props.fields.items as IPromoCardImageItem[];
  if (promoCards.length === 1) {
    // return lg / default
    return `w-[288px] ${props.fields.height}`;
  } else if (promoCards.length === 2) {
    // return md
    return 'w-[300px] md:w-[340px]';
  } else {
    // return sm
    return 'md:w-[288px]';
  }
}

function getBackgroundColourClass(backgroundColour: any) {
  if (!backgroundColour?.value) {
    return '';
  }
  switch (backgroundColour.value) {
    case BackgroundColours.WHITE:
      return 'bg-racq-true-white';
    case BackgroundColours.LIGHTGREY:
      return 'bg-racq-neutral-grey';
    case BackgroundColours.GREY:
      return 'bg-racq-anti-flash-white';
    default:
      return '';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { "data-test-id": _unref(dataTestId) }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.fields.heading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(RichText), {
              field: _ctx.fields.heading
            }, null, 8, ["field"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promoCardImages.value, (promoCardImage, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            "data-test-id": promoCardImage.fields.dataTestId?.value || _unref(dataTestId) + '_' + index
          }, [
            (promoCardImage.fields.isChevron.value && promoCardImage.fields.chevronUrl)
              ? (_openBlock(), _createBlock(_unref(Link), {
                  key: 0,
                  field: promoCardImage.fields.chevronUrl,
                  class: "group block no-underline active:no-underline shadow-md hover:shadow-xl rounded-lg active:rounded-lg active:!shadow-none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(PromoCardImageContent, {
                      promoCardImage: promoCardImage,
                      isWrappedInLink: true,
                      tagSize: _unref(TagSize),
                      tagBgColour: _unref(TagBgColour),
                      tagTypes: _unref(TagTypes),
                      getMaxImageWidthClasses: getMaxImageWidthClasses,
                      getBackgroundColourClass: getBackgroundColourClass,
                      isValidPrimaryButton: isValidPrimaryButton,
                      isValidSecondaryButton: isValidSecondaryButton
                    }, null, 8, ["promoCardImage", "tagSize", "tagBgColour", "tagTypes"])
                  ]),
                  _: 2
                }, 1032, ["field"]))
              : (_openBlock(), _createBlock(PromoCardImageContent, {
                  key: 1,
                  class: _normalizeClass({
                'shadow-md': promoCardImage.fields.showBorder,
                'hover:shadow-lg': promoCardImage.fields.showBorder,
              }),
                  promoCardImage: promoCardImage,
                  isWrappedInLink: false,
                  tagSize: _unref(TagSize),
                  tagBgColour: _unref(TagBgColour),
                  tagTypes: _unref(TagTypes),
                  getMaxImageWidthClasses: getMaxImageWidthClasses,
                  getBackgroundColourClass: getBackgroundColourClass,
                  isValidPrimaryButton: isValidPrimaryButton,
                  isValidSecondaryButton: isValidSecondaryButton
                }, null, 8, ["class", "promoCardImage", "tagSize", "tagBgColour", "tagTypes"]))
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ], 8, _hoisted_1))
}
}

})